<template>
    <div class="container-tips w-full">
        <div class="flex flex-row py-4">
            <div class="w-1/2 text-2xl pb-4 px-2">
                <a href="#" _target="blank">
                    <div
                        class="w-11 h-11 flex items-center justify-center p-8 pointer">
                        <i class="fa fa-facebook"></i>
                    </div>
                </a>
            </div>
            <div class="w-1/2 text-2xl px-2">
                <a href="#" _target="blank"><div
                    class="w-11 h-11 flex items-center justify-center  p-8 pointer">
                    <i class="fa fa-instagram"></i>
                </div>
                </a>
            </div>
            <div class="w-1/2 text-2xl px-2">
                <a href="#" _target="blank">
                    <div
                        class="w-11 h-11 flex items-center justify-center p-8 pointer">
                        <i class="fa fa-youtube-play"></i>
                    </div>
                </a>
            </div>
            <div class="w-1/2 text-2xl px-2">
                <a href="#" _target="blank">
                    <div
                        class="w-11 h-11  flex items-center justify-center p-8 pointer">
                        <i class="fa fa-linkedin"></i>
                    </div>
                </a>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "tips",
    data() {
        return {
            icon: true
        }
    },
}
</script>

<style lang="scss" scoped>

</style>